import Link from 'next/link';
import React from 'react';
import { IoBriefcaseOutline } from 'react-icons/io5';

import { Button } from '@mantine/core';

import { MarketingHelpers } from 'helpers/MarketingHelpers';

const JoinAsProButton = () => {
    return (
        <Button
            leftSection={<IoBriefcaseOutline />}
            component={Link}
            href={MarketingHelpers.urls.resourcepro.joinAsPro()}
            visibleFrom="sm"
        >
            Join as a PRO
        </Button>
    );
};

export { JoinAsProButton };
